// Literal class strings so Tailwind's JIT keeps them (no dynamic concatenation).
const CHIP: Record<string, string> = {
  red: 'border-wine-500/40 bg-wine-700/25 text-wine-200',
  white: 'border-gold-500/40 bg-gold-600/15 text-gold-200',
  rose: 'border-pink-400/40 bg-pink-500/15 text-pink-200',
  sparkling: 'border-amber-300/40 bg-amber-400/15 text-amber-200',
  orange: 'border-orange-400/40 bg-orange-500/15 text-orange-200',
  dessert: 'border-amber-500/40 bg-amber-600/15 text-amber-200',
  other: 'border-ink-800 bg-ink-800 text-cream-300/70',
};

export function WineColorChip({ color }: { color?: string | null }) {
  if (!color) return null;
  return (
    <span
      className={`inline-block shrink-0 rounded-full border px-2 py-0.5 text-[10px] capitalize ${CHIP[color] ?? CHIP.other}`}
    >
      {color}
    </span>
  );
}
